<div class="modal-header">
  <!--ep-task-action-modal-->
  <h4 class="modal-title">File Document</h4>
  <aurora-icon-button class="close" type="button" (click)="activeModal.dismiss('Cross click')" icon="times" size="large"></aurora-icon-button>
</div>
<div class="modal-body">
  <dataservice-error></dataservice-error>
  <div *ngIf="document" style="margin: 0px">
    <ep-document-file-edit-panel
      [document]="document"
      (filingReferanceChange)="getExistingTasks()"
    ></ep-document-file-edit-panel>
  </div>

  <!-- <div>filings: {{ filings$ | async | json }}</div> -->

  <div *ngFor="let filing of filings$ | async; let row = index">
    <ep-document-filing-edit-panel
      *ngIf="filing.DocLink_ID <= 0"
      [filing]="filing"
      [firstRow]="row === 0"
    ></ep-document-filing-edit-panel>
  </div>
  <hr />

  <ep-sub-panel panelType="transparent">
    <ep-field-section>
      <h4 style="font-size: 16px"><b>Current Filings</b></h4>
      <div *ngFor="let filing of filings$ | async; let row = index">
        <ep-document-filing-edit-panel
          *ngIf="filing.DocLink_ID > 0"
          [filing]="filing"
          [firstRow]="row === 0"
        ></ep-document-filing-edit-panel>
      </div>
    </ep-field-section>
  </ep-sub-panel>
  <hr />

  <ep-sub-panel panelType="transparent">
    <ep-field-section>
      <h4 style="font-size: 16px"><b>Link to Task</b></h4>
      <ep-selector
        class="w-100"
        [(value)]="model.taskLinkType"
        [values]="[
          { Code: 'NOTASK', Code_Desc: 'No Task Link' },
          { Code: 'EXISTINGTASK', Code_Desc: 'Link to Exisiting Task' },
          { Code: 'NEWTASK', Code_Desc: 'Create New Task' }
        ]"
        (valueChange)="getExistingTasks()"
      ></ep-selector>
    </ep-field-section>
  </ep-sub-panel>

  <div *ngIf="model.taskLinkType == 'NEWTASK'">
    <ep-sub-panel panelType="transparent">
      <ep-field-section>
        <ep-field columnSpan="6" label="Task Type" format="container">
          <ep-dropdown
            class="unity-form-group select"
            [codeValues]="objectList"
            [(ngModel)]="model.taskObjectCode"
            (ngModelChange)="taskObjectSelected()"
          ></ep-dropdown>
        </ep-field>
      </ep-field-section>
    </ep-sub-panel>
    <ep-task-action-edit-panel
      style="margin-top: 2px"
      taskActionMode="Pend"
      [taskActionOptions]="taskActionOptions"
    ></ep-task-action-edit-panel>
  </div>
  <div *ngIf="model.taskLinkType == 'EXISTINGTASK'">
    <div
      *ngIf="dsTasks.objectNodes.length > 0"
      style="
        border: dashed 2px gray;
        font-size: 0.8125rem;
        text-align: center;
        margin: 20px;
        max-height: 200px;
        overflow-y: auto;
      "
    >
      <!-- ngFor dsTasks.objectNodes here -->
      <table class="table">
        <tbody>
          <tr *ngFor="let task of dsTasks?.objectNodes">
            <td style="width: 100%" (click)="app.getSelectedText() && onTaskRowClicked(task)">
              <aurora-badge type="text" prominence="low" color="default" class="float-end" style="font-size: small">
                Assigned to {{ task?.Assigned_To?.Entity_Name }} ({{ task?.Assigned_To?.WorkGroup_Name }})
              </aurora-badge>
              <div [ngbTooltip]="task.Task_Desc" style="font-weight: 600">
                <sm-checkbox
                  [label]="task?.Task_Desc"
                  [checked]="model.selectedTaskID === task.Task_ID"
                  (click)="taskCheckBoxClick(task, $event)"
                ></sm-checkbox>
              </div>
              <div>
                {{ task?.Project?.Project_Desc }}
              </div>

              <div>Entity: {{ task?.Task_Reference?.Entity?.Entity_Name }}</div>
              <div>Contract: {{ task?.Task_Reference?.Contract?.Contract_Num }}</div>
              <div>Claim: {{ task?.Task_Reference?.Claim?.Book_Claim_Num }}</div>
            </td>
          </tr>
          <tr *ngIf="taskCount == 0 && (dsObject.status$ | async) == 2">
            No Task Activity Found
          </tr>
        </tbody>
      </table>
    </div>
    <div
      *ngIf="dsTasks.objectNodes.length === 0"
      style="border: dashed 2px gray; font-size: 0.8125rem; text-align: center; margin: 20px"
    >
      No Related Tasks Found
    </div>
  </div>
</div>
<div class="modal-footer">
  <!--ep-task-action-modal-->
  <aurora-button
    type="button"
    (click)="save()"
    [loading]="!model.autoOpenTask && app.dsTaskProcess.status == 'Loading'"
    variant="primary"
  >
    Save
  </aurora-button>
  <aurora-button
    type="button"
    [disabled]="model.taskLinkType == 'NOTASK'"
    (click)="saveAndStartTask()"
    [loading]="model.autoOpenTask && (app.dsTaskProcess.status == 'Loading' || app.dsTaskGet.status == 'Loading')"
    variant="secondary"
  ><span>Save &amp; Start Task</span>
  </aurora-button>
  <aurora-button type="button" (click)="saveAndRoute()" variant="secondary">Save &amp; Route</aurora-button>
  <aurora-button type="button" (click)="saveAndDistribute()" variant="secondary">Save &amp; Distribute</aurora-button>
  <aurora-button type="button" (click)="cancel()" variant="ghost">Cancel</aurora-button>
</div>
